import { Image } from 'antd';
import { FallbackObj } from 'helpers/ImageFallBack';
import React, { useEffect, useRef, useState } from 'react';

interface LazyImageProps {
    src: string;
    alt: string;
    style?: any;
    wrapperWidth: string;
    wrapperHeight: string;
    classNames?: string;
    imageClassName?: string;
    preview?: boolean;
}

const LazyLoadImage: React.FC<LazyImageProps> = ({ 
    src, 
    alt,
    style,
    wrapperWidth,
    wrapperHeight,
    classNames,
    imageClassName,
    preview 
}) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [previewVisible, setPreviewVisible] = useState(false);
    const imgRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); 
                }
            },
            { threshold: 0.1 } 
        );
        if (imgRef.current) {
            observer.observe(imgRef.current);
        }

        return () => {
            if (imgRef.current) {
                observer.unobserve(imgRef.current);
            }
        };
    }, []);

    const previewConfig = {
        visible: previewVisible,
        onVisibleChange: (vis:any) => setPreviewVisible(vis),
        mask: (
            <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                background: 'rgba(0, 0, 0, 0.1)',
                color: 'white',
                textAlign: 'center',
                padding: '8px 0',
                fontSize: '14px'
            }}>
                Önizleme
            </div>
        ),
        maskClassName: 'custom-preview-mask',
        align: {
            points: ['bc', 'tc'], // Bottom-center of image to top-center of preview
            offset: [0, 10],
        },
    };

    return (
        <div ref={imgRef} style={{width: wrapperWidth, height: wrapperHeight}} className={classNames}>
            {isVisible && (
                <Image 
                    className={imageClassName} 
                    preview={preview ? previewConfig : false} 
                    width={"100%"} 
                    style={style} 
                    height={"100%"} 
                    src={src} 
                    alt={alt} 
                    {...FallbackObj()}
                />
            )}
        </div>
    );
};

export default LazyLoadImage;